import React from 'react';

const Header = () => {
  return (
    <header className="text-white py-2">
        <div className='title'>
      <div className="container text-center">
        <img src='/assets/finalFightrmb.png' alt='logo' className='img-fluid' />
      </div>
        </div>
    </header>
  );
};

export default Header;